import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { ApiManager } from "services/api";
import { TeamSerializer } from "services/api/team";
import { CRUDAction, RequestAction } from "store/entities/actions";
import { INTEGRATION } from "store/entities/integrations";
import { TEAM, TeamActions } from "store/entities/teams/actions";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import {
  AGENT,
  AgentActions,
  IFetchCollectionSuccessPayload as IFetchAgentsCollectionSuccessPayload,
  IUpdateAgentSuccessPayload,
  selectAgentsAlphabetically,
} from "../agents";
import { IFetchLicenseSuccessPayload, LICENSE, selectDefaultTeamId } from "../license";

import {
  ICreateTeamPayload,
  IDeleteTeamPayload,
  IFetchTeamPayload,
  ITeam,
  IUpdateNotificationsPayload,
  IUpdateTagReminderTogglePayload,
  IUpdateTagReminderToggleSuccessPayload,
  IUpdateTeamPayload,
} from "./interfaces";
import { selectTeamsAlphabetically } from "./selectors";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchSingle(action: IActionWithPayload<string, IFetchTeamPayload>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.teamApi.fetch, id);
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const defaultTeamId = yield select(selectDefaultTeamId);
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const agents = yield select(selectAgentsAlphabetically);

  if (response.result) {
    yield put(
      TeamActions.fetchSuccess({ id, value: TeamSerializer.deserialize(response.result, agents, defaultTeamId) })
    );
    yield put(AgentActions.fetchCollection({}));
  } else {
    yield put(TeamActions.fetchFailure({ id, error: null }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const teamsResponse = yield call(ApiManager.teamApi.fetchAll);
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const agents = yield select(selectAgentsAlphabetically);
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const defaultTeamId = yield select(selectDefaultTeamId);

  if (teamsResponse.result) {
    yield put(
      TeamActions.fetchCollectionSuccess({
        values: TeamSerializer.deserializeList(teamsResponse.result, agents, defaultTeamId),
      })
    );
  } else {
    yield put(TeamActions.fetchCollectionFailure({ error: null }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* create(action: IActionWithPayload<string, ICreateTeamPayload>) {
  const team = { ...action.payload.value };
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.teamApi.createTeam, team);
  if (response.result) {
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const agents = yield select(selectAgentsAlphabetically);
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const defaultTeamId = yield select(selectDefaultTeamId);
    const newTeam = TeamSerializer.deserialize(response.result, agents, defaultTeamId);
    yield put(
      TeamActions.createSuccess({
        id: newTeam.id,
        value: newTeam,
      })
    );
  } else {
    yield put(TeamActions.createFailure({ error: response.error.error?.message, errorObject: response.error.error }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* update(action: IActionWithPayload<string, IUpdateTeamPayload>) {
  const team = { ...action.payload.value };
  const { name, agentIds, replyAddressID, replyName, autoassignmentAgentIDs } = team;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.teamApi.updateTeam, team.id, {
    name,
    agentIds,
    replyAddressID,
    replyName,
    autoassignmentAgentIDs,
  });
  if (response.result) {
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const agents = yield select(selectAgentsAlphabetically);
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const defaultTeamId = yield select(selectDefaultTeamId);
    yield put(
      TeamActions.updateSuccess({
        // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        id: team.id,
        value: TeamSerializer.deserialize(response.result, agents, defaultTeamId),
      })
    );
  } else {
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    yield put(TeamActions.updateFailure({ id: team.id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteTeam(action: IActionWithPayload<string, IDeleteTeamPayload>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.teamApi.deleteTeam, id);
  if (response.result) {
    yield put(TeamActions.deleteSuccess({ id }));
  } else {
    yield put(TeamActions.deleteFailure({ id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateNotifications(action: IActionWithPayload<string, IUpdateNotificationsPayload>) {
  const { teamId, settings } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.teamApi.updateTeam, teamId, { settings });
  if (response.result) {
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const agents = yield select(selectAgentsAlphabetically);
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const defaultTeamId = yield select(selectDefaultTeamId);
    const team = TeamSerializer.deserialize(response.result, agents, defaultTeamId);
    yield put(
      TeamActions.updateNotificationsSuccess({
        id: team.id,
        value: team,
      })
    );
  } else {
    yield put(TeamActions.updateNotificationsFailure({ id: teamId, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* agentsCollectionUpdated(action: IActionWithPayload<string, IFetchAgentsCollectionSuccessPayload>) {
  const { values: agents } = action.payload;
  yield put(TeamActions.syncAgents({ agents }));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* singleAgentUpdated(action: IActionWithPayload<string, IUpdateAgentSuccessPayload>) {
  const { value: agent } = action.payload;
  // @ts-expect-error TS(2322)
  yield put(TeamActions.syncUpdatedAgent({ agent }));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateDefaultTeam(action: IActionWithPayload<string, IFetchLicenseSuccessPayload>) {
  const { value: license } = action.payload;
  yield put(TeamActions.syncDefaultTeamId({ defaultTeamId: license.defaultTeamId }));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateTagReminder(action: IActionWithPayload<string, IUpdateTagReminderTogglePayload>) {
  const { tagReminder, teamID } = action.payload;

  const response = Array.isArray(teamID)
    ? // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      yield call(ApiManager.teamApi.batchUpdate, { ids: teamID as string[], fields: { settings: { tagReminder } } })
    : // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
      yield call(ApiManager.teamApi.updateTeam, teamID, { settings: { tagReminder } });

  if (response.result) {
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const agents = yield select(selectAgentsAlphabetically);
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const defaultTeamId = yield select(selectDefaultTeamId);

    const value = Array.isArray(teamID)
      ? TeamSerializer.deserializeList(
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          response.result.map((item: any) => item.doc),
          agents,
          defaultTeamId
        )
      : TeamSerializer.deserialize(response.result, agents, defaultTeamId);

    yield put(
      TeamActions.updateTagReminderToggleSuccess({
        id: Array.isArray(teamID) ? (value as ITeam[]).map(team => team.id) : (value as ITeam).id,
        value,
      })
    );
  } else {
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const teams = yield select(selectTeamsAlphabetically);
    yield put(
      TeamActions.updateTagReminderToggleFailure({
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        id: Array.isArray(teamID) ? teams.map((team: any) => team.id) : teamID,
        error: response.error.message,
        errorObject: response.error,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateTagReminderSuccess(action: IActionWithPayload<string, IUpdateTagReminderToggleSuccessPayload>) {
  const { value } = action.payload;
  const {
    // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'ITeam ... Remove this comment to see the full error message
    settings: { tagReminder },
  } = Array.isArray(value) ? value[0] : value;

  trackEngagement(`Tag reminder: ${tagReminder ? "activated" : "deactivated"}`, EventPlace.Settings, {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    teamIDs: Array.isArray(value) ? value.map(t => t.id) : [value.id],
  });

  yield put(
    ToastsActions.createToast({
      variant: ToastVariant.Success,
      content: getToastContent(ToastContent.TAG_REMINDER_SUCCESS, {
        tagReminder,
        multiple: Array.isArray(value),
      }),
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateTagReminderFailure() {
  yield put(
    ToastsActions.createToast({
      variant: ToastVariant.Error,
      content: getToastContent(ToastContent.TAG_REMINDER_FAILURE),
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* teamsSagas() {
  yield all([
    takeLatest(TEAM[CRUDAction.FETCH_SINGLE][RequestAction.REQUEST], fetchSingle),
    takeLatest(
      [TEAM[CRUDAction.FETCH_COLLECTION][RequestAction.REQUEST], INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FINISHED],
      fetchCollection
    ),
    takeLatest(TEAM[CRUDAction.CREATE][RequestAction.REQUEST], create),
    takeLatest(TEAM[CRUDAction.UPDATE][RequestAction.REQUEST], update),
    takeLatest(TEAM[CRUDAction.DELETE][RequestAction.REQUEST], deleteTeam),
    takeLatest(TEAM.UPDATE_NOTIFICATIONS[RequestAction.REQUEST], updateNotifications),
    takeLatest(AGENT[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS], agentsCollectionUpdated),
    takeLatest(AGENT[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS], singleAgentUpdated),
    takeLatest(LICENSE[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS], updateDefaultTeam),
    takeLatest(TEAM.UPDATE_TAG_REMINDER_TOGGLE[RequestAction.REQUEST], updateTagReminder),
    takeLatest(TEAM.UPDATE_TAG_REMINDER_TOGGLE[RequestAction.SUCCESS], updateTagReminderSuccess),
    takeLatest(TEAM.UPDATE_TAG_REMINDER_TOGGLE[RequestAction.FAILURE], updateTagReminderFailure),
  ]);
}
